import { cn } from "@/lib/utils";
import { CompositeChoice } from "@/types/questionnaries";
import { FC } from "react";
import MultipleChoiceItem from "./multiple-choice-item";

type MultipleChoiceListProps = {
  choice: CompositeChoice;
  level?: number;
  className?: string;
  disabled?: boolean;
};

const MultipleChoiceList: FC<MultipleChoiceListProps> = ({
  choice,
  level = 0,
  className,
  disabled,
}) => {
  return (
    <ul className={cn("grid gap-3", className)}>
      {choice.choices.map((choice) => (
        <MultipleChoiceItem
          key={choice.id}
          choice={choice}
          level={level}
          disabled={disabled}
        />
      ))}
    </ul>
  );
};

export default MultipleChoiceList;
